import { createFileRoute, redirect } from '@tanstack/react-router';

/** Bare /teacher opens the shared role-aware dashboard. */
export const Route = createFileRoute('/_authed/teacher/')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
